import { BadgeCheck, MapPin, Landmark, Gift } from "lucide-react";

const PILLARS = [
  { icon: BadgeCheck, title: "3rd-party tested", text: "Certificates of analysis on request", testid: "trust-tested" },
  { icon: MapPin, title: "Ships from Canada", text: "Domestic shipping, no customs", testid: "trust-shipping" },
  { icon: Landmark, title: "Interac e-Transfer", text: "Simple, secure checkout", testid: "trust-payment" },
  { icon: Gift, title: "Rewards points", text: "Earn on every order", testid: "trust-rewards" },
];

export const TrustStrip = () => (
  <div className="border-y border-[#DDD7CF]/70 bg-white/60 backdrop-blur" data-testid="trust-strip">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 lg:grid-cols-4 lg:divide-x divide-[#DDD7CF]/60">
      {PILLARS.map(({ icon: Icon, title, text, testid }, i) => (
        <div
          key={testid}
          data-testid={testid}
          className={`flex items-center gap-3 py-4 lg:px-6 lg:first:pl-0 lg:last:pr-0 border-[#DDD7CF]/60 ${
            i % 2 === 0 ? "pr-3 border-r lg:border-r-0" : "pl-3"
          } ${i >= 2 ? "border-t lg:border-t-0" : ""}`}
        >
          <Icon className="w-5 h-5 text-[#2D6A4F] shrink-0" />
          <div className="min-w-0">
            <p className="text-xs sm:text-sm font-semibold text-[#1A1A1A] leading-tight">{title}</p>
            <p className="hidden sm:block text-[11px] sm:text-xs text-[#6E675F] truncate">{text}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
